export default __webpack_public_path__ + "static/logo-dph-246438cd350ed1fef47cba4ffdaff844.png";